<template>
  <nav>
    <v-app-bar app flat>
      <v-app-bar-nav-icon
        class="grey--text"
        @click="$store.dispatch('drawer/toggle')"
      ></v-app-bar-nav-icon>

      <v-toolbar-title class="grey--text">
        Wenn
      </v-toolbar-title>
    </v-app-bar>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',

  methods: {
    goToDashboard() {
      if (this.$route.name !== 'Dashboard') {
        this.$router.push({ name: 'Dashboard' });
      }
    }
  }
};
</script>

<style>
.navbarActive {
  background-color: #f05064;
}

.pointer {
  cursor: pointer;
}
</style>
